var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4319 17.697C13.1472 16.5262 17.1134 13.3064 16.8675 9.0738C16.7659 7.48286 16.0822 5.98499 14.9469 4.86586C13.8116 3.74674 12.3041 3.08467 10.7118 3.00594C9.84354 2.9692 8.9768 3.1086 8.16382 3.41573C7.35083 3.72286 6.60843 4.19137 5.98132 4.79304C5.35422 5.39471 4.85539 6.11709 4.51488 6.91667C4.17437 7.71625 3.99923 8.57648 4 9.44554C4 13.4996 7.80522 16.5642 9.44147 17.6941C9.73503 17.8935 10.0818 18.0002 10.4367 18.0002C10.7916 18.0002 11.1383 17.8935 11.4319 17.6941V17.697ZM7.65887 9.00648C7.65887 8.4565 7.82195 7.91887 8.1275 7.46158C8.43306 7.00429 8.86735 6.64788 9.37546 6.43741C9.88357 6.22694 10.4427 6.17188 10.9821 6.27917C11.5215 6.38647 12.017 6.65131 12.4059 7.0402C12.7948 7.42909 13.0596 7.92457 13.1669 8.46398C13.2742 9.00339 13.2191 9.5625 13.0087 10.0706C12.7982 10.5787 12.4418 11.013 11.9845 11.3186C11.5272 11.6241 10.9896 11.7872 10.4396 11.7872C9.70234 11.7864 8.9955 11.4932 8.47418 10.9719C7.95286 10.4506 7.65964 9.74374 7.65887 9.00648Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f4e1191fa0110f6e355764a1a92394ab.svg";
export { ForwardRef as ReactComponent };